export default __webpack_public_path__ + "static/4-4079ec12997345e1039db584082713e4.png";